import { Fragment, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { titles } from "../../Titles";
import { MagnifyingGlassIcon, XMarkIcon } from "@heroicons/react/24/outline";

const PublicTalkTitles = ({ open, setOpen }) => {
  const cancelButtonRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState(titles);

  // Function to handle changes in the input field
  const handleInputChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    if (value !== "") {
      const filtered = titles.filter((item) => item?.number === value);
      setFilteredData(filtered);
    } else {
      setFilteredData(titles);
    }
  };
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 w-full sm:max-w-3xl">
                <div className={"flex items-center px-3 mt-1 justify-between"}>
                  <div className={"font-bold"}>Τίτλοι ομιλιών</div>
                  <button
                    className={
                      "float-right p-1 bg-gray-100 hover:bg-gray-50 rounded-xl focus:outline-none outline-none"
                    }
                    onClick={() => setOpen(false)}
                  >
                    <XMarkIcon className={"w-6 h-6"} />
                  </button>
                </div>

                <div className="max-w-md mx-auto px-3 py-2">
                  <div className="relative flex items-center w-full h-10 rounded-lg ring-1 shadow ring-gray-300 bg-white overflow-hidden">
                    <div className="grid place-items-center h-full w-12 text-gray-400">
                      <MagnifyingGlassIcon className={"w-6 h-6"} />
                    </div>

                    <input
                      value={searchTerm}
                      className="peer h-full w-full outline-none text-sm text-gray-700 pr-2"
                      type="text"
                      id="search"
                      placeholder="Αναζήτηση ομιλίας.."
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className={"p-2 overflow-y-scroll h-[400px] sm:h-full"}>
                  {filteredData.map((item, index) => (
                    <p
                      key={item?.number}
                      className={
                        "text-sm border-b-[1px] font-semibold last:border-0 p-1"
                      }
                    >
                      {item?.number} - {item?.name}
                    </p>
                  ))}
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default PublicTalkTitles;
